export const recommendationToNavigationResolver = {
  methods: {
    resolveRecommendationToNavigation(recommendation) {
      if (!recommendation.query) return;
      this.$store.commit("overview/reset");
      this.$store.commit("filters/resetCommons");
      this.$store.commit("navigation/setCurrentSubNavItem", null);

      switch (recommendation.query.key) {
        case "priceSale":
          this.$store.commit("navigation/setCurrentNavItem", { name: "sale" });
          this.$store.commit("filters/setFieldByKeyValue", {
            key: "onSale",
            value: true
          });
          this.$router.push({ name: "sale" });
          break;
        case "sustainable":
          this.$store.commit("navigation/setCurrentNavItem", {
            name: "clothing"
          });
          this.$store.commit("filters/setFieldByKeyValue", {
            key: "sustainable",
            value: true
          });
          this.$router.push({ name: "clothing" });
          break;

        case "category":
          // eslint-disable-next-line no-case-declarations
          let navTo = "clothing";
          if (recommendation.query.value === "shoes") {
            navTo = "shoes";
            this.$store.commit("filters/setOneSelectValue", {
              key: "type",
              value: "shoes"
            });
            this.$store.commit("navigation/setCurrentSubNavItem", "shoes");
          }
          if (recommendation.query.value === "bag") {
            navTo = "accessories";
            this.$store.commit("filters/setOneSelectValue", {
              key: "type",
              value: "pouch"
            });
            this.$store.commit("navigation/setCurrentSubNavItem", "pouch");
          }

          this.$store.commit("navigation/setCurrentNavItem", { name: navTo });
          this.$router.push({ name: navTo });
          break;
        case "type":
          this.$store.commit("navigation/setCurrentNavItem", {
            name: "clothing"
          });
          this.$router.push({ name: "clothing" });
          this.$store.commit("filters/setOneSelectValue", {
            key: "type",
            value: recommendation.query.value
          });
          this.$store.commit(
            "navigation/setCurrentSubNavItem",
            recommendation.query.value
          );
          break;
        default:
        // s
      }
    }
  }
};
